import { withInstall } from '@vuemap/vue-amap-util'
import TileLayer from './TileLayer.vue'

export const ElAmapLayerTile = withInstall(TileLayer)
export default ElAmapLayerTile
